import { ChipSearch } from "../atoms/Chip";

export default function SearchAnchorNav({
  productsAndServices,
  businessSegment,
  news,
  pages,
  translations
}) {
  return (
    <nav
      className={`hero-nav-locked sticky h-53 z-10 container-custom bg-gray-200 duration-300`}
    >
      <ul className="flex h-full gap-x-24 items-center w-full overflow-x-auto overflow-y-hidden">
        <li className="h-full flex items-center py-12 border-t-2 border-solid border-gray-900">
          <span className="text-14 font-medium tracking-05 leading-115 text-gray-500 whitespace-nowrap">
            {translations['results_by']}
          </span>
        </li>
        {productsAndServices?.length ? (
          <li className="py-12">
            <ChipSearch
              text={translations['products_services']}
              href="#products"
              count={productsAndServices?.length}
            />
          </li>
        ) : (
          <></>
        )}
        {businessSegment?.length ? (
          <li className="py-12">
            <ChipSearch
              text={translations['business_segments']}
              href="#business"
              count={businessSegment?.length}
            />
          </li>
        ) : (
          <></>
        )}
        {news?.length ? (
          <li className="py-12">
            <ChipSearch text={translations['news_and_media']} href="#news" count={news?.length} />
          </li>
        ) : (
          <></>
        )}
        {pages?.length ? (
          <li className="py-12">
            <ChipSearch text={translations['pages']} href="#pages" count={pages?.length} />
          </li>
        ) : (
          <></>
        )}
      </ul>
    </nav>
  );
}
